// extracted by mini-css-extract-plugin
export default {"avatar":"styles_avatar__7UfiY","avatar-img":"styles_avatar-img__vRNjZ","avatar-placeholder":"styles_avatar-placeholder__Neqlq"};